// extracted by mini-css-extract-plugin
export default {"body":"styles_body__CbJ8m","content":"styles_content__Kre4M"};